/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { TimelineItem } from "./timeline-item";
import { RichText } from "@simplicitycms/simplicity-richtext";

const TimelineComponent = (props) => {
    const { component } = props;
    const { description, link, section, subtitle, timelines, title } = component || {};
    const { text: link_text, url } = link || {};

    const hasLink = link && link_text && url;
    const hasTimelineItems = timelines && timelines.length > 0;

    return (
        <div className='simplicity-timeline'>
            <div className='timeline-left'>
                {section && <h4>{section}</h4>}
                {title && <h2>{title} {subtitle && <span>{subtitle}</span>}</h2>}

                {description && <RichText richtext={description} />}

                {hasLink &&
                    <div className='timeline-link-button'>
                        <a href={url}>
                            {link_text}
                        </a>
                    </div>
                }

            </div>
            {hasTimelineItems &&
                <div className='timeline-right'>
                    {timelines.map((timeline, index) => {
                        return (
                            <TimelineItem item={timeline} key={`timeline-item-${index}`} />
                        );
                    })}
                </div>
            }
        </div>
    );
};

TimelineComponent.displayName = "TimelineComponent";
export { TimelineComponent };
